<template>
</template>

<script>
</script>

<style>
</style><template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="促销名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="促销类型" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.type === 1" size="mini" type="danger">秒杀</el-tag>
					<el-tag v-if="scope.row.type === 2" size="mini" type="danger">满减</el-tag>
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="产品列表" placement="top">
					  <el-button type="warning" icon="el-icon-tickets" size="mini" circle @click="handlelist(scope.row.id)"></el-button>		
					</el-tooltip>
<!-- 					<el-tooltip class="item" effect="dark" content="产品" placement="top">
					  <el-button type="warning" icon="el-icon-goods" size="mini" circle @click="handleSel(scope.row.id)"></el-button>		
					</el-tooltip> -->
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
		    <el-form-item label="活动名称" prop="name">
		      <el-input v-model="form.name" placeholder="请输入活动名称" type="text" clearable />
		    </el-form-item>
		   <el-form-item  label="状态">
		      <el-radio-group v-model="form.status">
		      	<el-radio :label="1">使用</el-radio>
		      	<el-radio :label="2">停用</el-radio>
		      </el-radio-group>
		    </el-form-item>
			<el-form-item  label="类型">
			   <el-radio-group v-model="form.type">
			   	<el-radio :label="1">秒杀</el-radio>
			   	<el-radio :label="2">免减</el-radio>
			   </el-radio-group>
			 </el-form-item>
			 <el-form-item label="起止时间" prop="time">
			   <el-date-picker
			        v-model="form.time"
			        type="datetimerange"
					@input="dateChange"
			        value-format="yyyy-MM-dd HH:mm:ss"
			        style="width: 350px;"
			        range-separator="至"
			        start-placeholder="开始日期"
			        end-placeholder="结束日期">
			    </el-date-picker>
			 </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
		
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'promotion',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					name:'',
					status:1,
					type:1,//1秒杀 2满减 3团购
					time:[],
					stime:null,
					etime:null,
				},
				rules:{
					name: [
					  { required: true, message: '请输入促销名称', trigger: 'blur' }
					],
				},
			}
		},
		mounted() {
			this.getGoodsCat()
			
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name
				}
				let str = ''
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? '|--' : '--'
				}
				return str + ' ' +item.name;
			}
		},
		methods:{
			dateChange(e){
				this.$forceUpdate()
			},
			handlelist(id){
				this.$router.push({
				  path:"/promotion_goods",
				  query: {
					  id:id
				  }
				})
			},
			reset() {
			  this.form = {
			    name:'',
			    status:1,
			    type:1,//1秒杀 2满减 3团购
				time:[],
			    stime:null,
			    etime:null,
			  }
			  this.resetForm('form')
			},
			getGoodsCat(){
				this.axios.get('/manage/goods_cat/list').then(res=>{
					if(res.status){
						let data = res.data
						let index = data.findIndex((v)=>v.id === 3)
						data.splice(index,1)
						this.goods_cat = data
					}
				})
			},
			handleEdit(row) {
			  this.reset()
			  this.open = true
			  this.title = '编辑'
			  this.form = JSON.parse(JSON.stringify(row))
			  this.form.time = [this.form.stime,this.form.etime]
			},
			handleSubmit(){
			   let time = this.form.time
			   if(time.length > 0){
				   this.form.stime = time[0]
				   this.form.etime = time[1]
			   }
			   this.$refs.form.validate(valid => {
			     if (valid) {
			       if (this.form.sort) {
			         this.form.sort = parseInt(this.form.sort)
			       }
			       if (this.form.id === undefined) {
			         this.axios.post('/manage/'+this.preUrl + '/add', this.form).then(res => {
			           if (res.status) {
			             this.$message.success('添加成功')
			             this.open = false
			             this.getList()
			           } else {
			             this.$message.error(res.msg)
			           }
			         })
			       } else {
			         this.axios.put('/manage/'+this.preUrl + '/edit/' + this.form.id, this.form).then(res => {
			           if (res.status) {
			             this.$message.success('修改成功')
			             this.open = false
			             this.getList()
			           } else {
			             this.$message.error(res.msg)
			           }
			         })
			       }
			     }
				})
			},
			handleSel(id){
				this.getGoods()
				this.$nextTick(()=>{
				  this.title = '商品列表'
				  this.openGoods = true
				  this.id = id
				})
			},
			getGoods(){
				this.axios.get('/manage/goods/sel_goods',{
				  params: {
					page:this.goods_page.page,
					limit:this.goods_page.limit,
					keyword:this.tableForm.keyword,
					cat_id:this.tableForm.cat_id
				  }
				}).then(res=>{
				  this.goods_page.total = res.data.total
				  this.goodsData = res.data.list
				  // 默认选中
				  this.getData()
				})
			},
			handleGoodsSel(index,item){
				this.form.value = item.id
				this.openGoods = false
				this.title = '新增'
			},
			handleSelectionChange(e){
				let ids = [];
				if(e.length > 0){
					e.forEach((item)=>{
						ids.push({'id':item.id,'price':item.price});
					})
				}
				this.ids = ids
			},
			handleAllSubmit(){
				this.$confirm('确定要添加吗？', '提示', {
				  confirmButtonText: '添加',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  this.loading = true
				  this.axios.post('/manage/'+this.preUrl + '/add_goods',{
					   ids:this.ids,
					   id:this.id,
					}).then(res => {
						if (res.status) {
						  this.$message({
							message: '添加成功',
							type: 'success'
						  })
						  this.getList()
						}
						this.openGoods = false
						this.loading = false
				  }).catch(err => {
					   this.loading = false
				  })
				})
			},
			changeState(index, name, className) {
			  this.editable = new Array(this.goodsData.length)
			  this.editable[index] = true
			  this.saveItem = this.goodsData[index]
			  this.$set(this.editable, index, true)
			  // 让input自动获取焦点
			  this.$nextTick(function() {
				var editInputList = document.getElementsByClassName(className)
				const input = editInputList[0].children[0]
				input.focus()
				input.onblur = (e) => {
				  this.$set(this.editable, index, false)
				}
			  })
			},
			getData(){
				this.axios.post('/manage/'+this.preUrl + '/get_goods',{
				   id:this.id,
				}).then(res => {
					if (res.status) {
						let list = []
						let rows = res.data.list
						if(rows.length>0){
							this.goodsData.forEach((item) => {
								rows.forEach(val => {
									if (val.goods_id === item.id) {
										list.push(item)
									}
							   })
							})
						}
						console.log(list)
						if (list) {
							list.forEach((row) => {
							  this.$refs.dataTable.toggleRowSelection(row, true)
							})
						}
					}
				})
			},
		}
	}
</script>

<style>
</style>